import { AccordionBody, DescriptionTypography } from "./PathCourseAccordion.styles";
import { ActivityDotNavigation, ActivityItem } from "../../components/CourseActivityCard";
import { SkeletonCard } from "../../components/ModalEditionChange/SkeletonCard";
import type {  ReferencedCourse, ReferencedLearningActivity } from "../../types";

const ActivityAccordion = ({
  course,
  isLoading,
  activities,
  isStandaloneComponent=false,
  initialActiveLoId
}:{
  course:ReferencedCourse,
  isLoading:boolean,
  activities: ReferencedLearningActivity[] | ActivityItem[],
  isStandaloneComponent?:boolean,
  initialActiveLoId?: number | null
}) => {

  return (
    <AccordionBody isStandaloneComponent={ isStandaloneComponent }>
      { course?.shortDescription && !isStandaloneComponent && (
        <DescriptionTypography>
          { course.shortDescription }
        </DescriptionTypography>
      ) }

      { isLoading && <SkeletonCard /> }

      { !isLoading && activities?.length > 0 && (
        <ActivityDotNavigation activities={ activities as ActivityItem[] } initialActiveLoId={ initialActiveLoId } />
      ) }
    </AccordionBody>
  );
};

export default ActivityAccordion;
